module.exports = __webpack_public_path__ + "img/logo.16a6db0d.png";